// extracted by css-extract-rspack-plugin
export default {"statusTag":"styles-module__statusTag--me_M8"};